<template>
    <div>
        <div>
            <el-button type="primary" @click="addCommodity">添加商品</el-button>
            <el-button type="danger" @click="deleteCommodity">删除商品</el-button>
        </div>
        <div style="margin-top: 15px;">
            <el-table ref="multipleTable" :data="commodityData" style="width: 100%" element-loading-text="数据正在加载中"
                      @selection-change="handleSelectionChange" :header-cell-style="headClass" :row-style="rowClass">
                <el-table-column type="selection" width="60"></el-table-column>
                <el-table-column prop="productId" label="商品id" sortable></el-table-column>
                <el-table-column prop="name" label="商品名"></el-table-column>
                <el-table-column prop="category" label="商品类型"></el-table-column>
                <el-table-column label="商品图片">
                    <template slot-scope="scope">
                        <img :src="smallImage(scope.row.image)" style="width: 30px;height: 30px;" />
                    </template>
                </el-table-column>
                <el-table-column prop="scheme" label="分润方案"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <button @click="updateCommodity(scope.row)">修改商品</button>
                        <button @click="readyUpdateProfitSharing(scope.row)">选择分润方案</button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background style="text-align:right;margin-top: 15px;margin-bottom: 55px;"
                           @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
        <el-dialog title="添加商品" :visible.sync="myDialog" :before-close="handleClose" :close-on-click-modal="false">
            <div>
                <div>
                    <strong>基本属性</strong>
                    <hr class="hrClass" />
                </div>
                <div v-if="addProduct" style="margin-top: 10px;">
                    <span>商品类目</span>
                    <el-cascader :options="commodityClasses" style="margin-left: 40px;" :props="commodityProps"
                                 v-model="selectList" @change="selectChange"></el-cascader>
                </div>
                <div v-if="updateProduct" style="margin-top: 10px;">
                    <span>商品类目</span>
                    <span style="margin-left: 40px;">{{category}}</span>
                </div>
                <div v-if="commodityShow">
                    <div style="margin-top: 15px;">
                        <div>
                            <div>
                                <span>商品名称</span>
                                <el-input type="text" v-model="commodityName" style="width: 217px;margin-left: 40px;">
                                </el-input>
                            </div>
                            <div style="margin-top: 10px;">
                                <table>
                                    <tr>
                                        <td style="width: 56px;">
                                            <span>图片</span>
                                        </td>
                                        <td>
                                            <div style="margin-left: 35px;" class="avatarDiv">
                                                <el-upload :action="updateAction" :file-list="mainImage"
                                                           list-type="picture-card" :on-success="handleAvatarSuccess"
                                                           :on-remove="handleRemove"
                                                           :before-upload="beforeAvatarUpload">
                                                    <i class="el-icon-plus"></i>
                                                </el-upload>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div style="margin-top: 10px;">
                                <span>描述说明</span>
                                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="description">
                                </el-input>
                            </div>
                        </div>
                        <div v-if="keyProps.length > 0" style="margin-top: 10px;">
                            <strong>关键属性</strong>
                            <hr class="hrClass" />
                        </div>
                        <table class="tableClass">
                            <tr v-for="item in keyProps">
                                <td class="tdClass">{{item.name}}</td>
                                <td class="tdClass1">
                                    <myinput v-if="!item.enumProp" @changeInput="changeKey" :pid="item.pid"
                                             :myValue="item.value"></myinput>
                                    <myselect v-else-if="item.enumProp && !item.multi" :myoptions="item.values"
                                              :myValue="item.value" :pid="item.pid" @changeSelect="changeKey">
                                    </myselect>
                                    <mymutiselect v-else :myoptions="item.values" :pid="item.pid" :myValue="item.value"
                                                  @changeCheck="changeKey"></mymutiselect>
                                </td>
                            </tr>
                        </table>
                        <div v-if="otherProps.length > 0" style="margin-top: 10px;">
                            <strong>其他属性</strong>
                            <hr class="hrClass" />
                        </div>
                        <table class="tableClass">
                            <tr v-for="item in otherProps">
                                <td class="tdClass">{{item.name}}</td>
                                <td class="tdClass1">
                                    <myinput v-if="!item.enumProp" @changeInput="changeOther" :pid="item.pid"
                                             :myValue="item.value"></myinput>
                                    <myselect v-else-if="item.enumProp && !item.multi" :myoptions="item.values"
                                              :myValue="item.value" :pid="item.pid" @changeSelect="changeOther">
                                    </myselect>
                                    <mymutiselect v-else :myoptions="item.values" :pid="item.pid" :myValue="item.value"
                                                  @changeCheck="changeOther"></mymutiselect>
                                </td>
                            </tr>
                        </table>
                        <div v-if="saleProps.length > 0" style="margin-top: 10px;">
                            <strong>销售属性</strong>
                            <hr class="hrClass" />
                        </div>
                        <table class="tableClass">
                            <tr v-for="item in saleProps">
                                <td class="tdClass">{{item.name}}</td>
                                <td class="tdClass1">
                                    <myinput v-if="!item.enumProp" @changeInput="changeSale" :pid="item.pid"
                                             :myValue="item.value"></myinput>
                                    <myselect v-else-if="item.enumProp && !item.multi" :myoptions="item.values"
                                              :myValue="item.value" :pid="item.pid" @changeSelect="changeSale">
                                    </myselect>
                                    <mymutiselect v-else :myoptions="item.values" :pid="item.pid" :myValue="item.value"
                                                  @changeCheck="changeSale"></mymutiselect>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div>
                        <el-button @click="getCommodityList">创建商品列表</el-button>
                    </div>
                    <div v-if="commodityListShow">
                        <table style="width: 80%;text-align: center;">
                            <tr>
                                <th v-for="item in saleList">{{item.name}}</th>
                                <th v-if="saleList.length == 0">规格</th>
                                <th>金额</th>
                                <!-- 因为现阶段是租赁设备版本，不存在库存的概念，所以暂时隐藏并默认取值为10000,之后如果需要改成如电商那样通用的版本则解开这俩个被注释的地方 -->
                                <!--<th>数量</th>-->
                                <!-- <th>操作</th> -->
                            </tr>
                            <tr v-for="(item,index) in skuList">
                                <td v-for="item1 in item">
                                    <span v-if="item1.isProp">{{item1.valueName}}</span>
                                    <el-input v-if="item1.isMoney" type="text" v-model="item1.money"
                                              style="width: 100px;"></el-input>
                                    <!--<el-input v-if="item1.isCount" type="text" v-model="item1.count" style="width: 100px;"></el-input>-->
                                </td>
                                <td><el-button type="danger" @click="removeFromSkuList(item,index)">移除</el-button></td>
                            </tr>
                        </table>
                        <el-button :loading="loadingForAdd" v-if="addProduct" @click="commodityMethod('add')">创建商品
                        </el-button>
                        <el-button :loading="loadingForUpdate" v-if="updateProduct" @click="commodityMethod('update')">
                            修改商品</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="选择分润方案" :visible.sync="profitSharingDialog" :close-on-click-modal="false" width="450px">
            <div>
                <span>分润方案</span>
                <el-select v-model="sid" filterable style="width: 217px;margin-left: 40px;">
                    <el-option v-for="scheme in profitSharingSchemes" :label="scheme.name" :value="scheme.sid" />
                </el-select>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="profitSharingDialog = false">取 消</el-button>
                <el-button type="primary" @click="updateProfitSharingScheme">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import myselect from '@/components/myselect'
    import mymutiselect from '@/components/mymutiselect'
    import myinput from '@/components/myinput'
    import axios from 'axios'

    export default {
        name: 'productSet',
        components: {
            myselect,
            mymutiselect,
            myinput
        },
        data() {
            return {
                commodityProps: {
                    value: 'all',
                    label: 'label'
                },
                loadingForAdd: false,
                loadingForUpdate: false,
                commodityClasses: [],
                selectList: [],
                keyProps: [],
                saleProps: [],
                otherProps: [],
                keyList: [],
                saleList: [],
                otherList: [],
                customerProps: "",
                saleStr: "",
                binds: "",
                mainImage: [],
                commodityName: "",
                description: "",
                profitSharingDialog: false,
                commodityShow: false,
                commodityListShow: false,
                addProduct: false,
                updateProduct: false,
                myDialog: false,
                skuList: [],
                category: "",
                total: 0,
                currentPage: 1,
                pageSize: 10,
                multipleSelection: [],
                commodityData: [],
                productId: '',
                cid: '',
                sid: 0,
                profitSharingSchemes: [],
                updateSchemeProductId: {
                    productId: '',
                },
                updateAction: this.$store.getters.getApiValue + "/product/uploadImage.do"
            }
        },
        watch: {},
        computed: {},
        mounted() {
            this.initPage();
        },
        beforeDestroy() {},
        methods: {
            initPage() {
                var thiz = this;
                const loading = this.$loading({
                    lock: true,
                    text: '获取表格数据中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                setTimeout(() => {
                    loading.close();
                }, 3000);
                axios.get(this.$store.getters.getApiValue + '/product/listByCid.do', {
                    params: {
                        cid: 0
                    }
                }).then(function(response) {
                    loading.close();
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.total = data.totalCount;
                        thiz.commodityData = data.data;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    loading.close();
                    thiz.$message.error("系统异常,请与管理员联系!");
                });
                axios.get(this.$store.getters.getApiValue + '/category/all.do')
                    .then(function(response) {
                        var data = response.data;
                        if (data.status == "200") {
                            thiz.getStandardList(data.data);
                        } else {
                            thiz.$message.error(data.message);
                        }
                    }).catch(function(error) {
                        thiz.$message.error("系统异常,请与管理员联系!");
                    });
            },
            //获取商品类目，这里我的实现方式是将获得的list进行格式化为级联选择器el-cascader的标准数据格式.
            getStandardList(list) {
                for (var i = 0; i < list.length; i++) {
                    if (list[i].parent) {
                        var children = this.getChildren(list[i].children);
                        var selectOption = {
                            label: list[i].name,
                            all: {
                                value: list[i].cid,
                                label: list[i].name,
                            },
                            children: children
                        }
                        this.commodityClasses.push(selectOption)
                    } else {
                        var selectOption = {
                            label: list[i].name,
                            all: {
                                value: list[i].cid,
                                label: list[i].name,
                            },
                            children: null
                        }
                        this.commodityClasses.push(selectOption)
                    }
                }
            },
            //getStandardList所调用的方法，作用是格式化list中对象的子对象，因为后台传的list的一些对象会有children属性，
            //所以需要将其也格式化为级联选择器el-cascader的标准数据格式.
            getChildren(list) {
                var result = [];
                for (var i = 0; i < list.length; i++) {
                    if (list[i].parent) {
                        var children = this.getChildren(list[i].children);
                        var selectOption = {
                            label: list[i].name,
                            all: {
                                value: list[i].cid,
                                label: list[i].name,
                            },
                            children: children
                        }
                        result.push(selectOption);
                    } else {
                        var selectOption = {
                            label: list[i].name,
                            all: {
                                value: list[i].cid,
                                label: list[i].name,
                            },
                            children: null
                        }
                        result.push(selectOption);
                    }
                }
                return result;
            },
            //商品类目选择变化后所调用的change方法，用于初始化新增商品的数据表单.
            selectChange() {
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/category/listByCid.do', {
                    params: {
                        cid: this.selectList[this.selectList.length - 1].value
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        var list = data.data;
                        thiz.keyProps = [];
                        thiz.saleProps = [];
                        thiz.otherProps = [];
                        thiz.commodityList = [];
                        for (var i = 0; i < list.length; i++) {
                            var commodityItem = {
                                pid: list[i].pid,
                                enumProp: list[i].enumProp,
                                value: ""
                            }
                            if (list[i].keyProp && !list[i].saleProp) {
                                thiz.keyProps.push(list[i]);
                                thiz.keyList.push(commodityItem);
                            } else if (!list[i].keyProp && list[i].saleProp) {
                                thiz.saleProps.push(list[i]);
                                commodityItem.name = list[i].name;
                                commodityItem.values = list[i].values;
                                commodityItem.adminProp = list[i].adminProp;
                                thiz.saleList.push(commodityItem);
                            } else {
                                thiz.otherProps.push(list[i]);
                                thiz.otherList.push(commodityItem);
                            }
                        }
                        thiz.commodityShow = true;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    thiz.$message.error("系统异常,请与管理员联系!");
                });
            },
            //因为这是动态表单，而一共有三种属性list，分别是关键属性，销售属性和其他属性，我这边的根据其不同区域放到了不同list中了，
            //而这些list进行页面渲染后就出现在不同的区域中，而同时我在展示填充的表单是采用自定义组件myinput等的方式进行的，
            //那么这3个change方法就是用于接收子组件传回数据进行动态修改这三种list中的对象的value值.
            changeKey(pid, value) {
                for (var i = 0; i < this.keyList.length; i++) {
                    if (this.keyList[i].pid == pid) {
                        this.keyList[i].value = value;
                        return;
                    }
                }
            },
            changeSale(pid, value) {
                for (var i = 0; i < this.saleList.length; i++) {
                    if (this.saleList[i].pid == pid) {
                        this.saleList[i].value = value;
                        return;
                    }
                }
            },
            changeOther(pid, value) {
                for (var i = 0; i < this.otherList.length; i++) {
                    if (this.otherList[i].pid == pid) {
                        this.otherList[i].value = value;
                        return;
                    }
                }
            },
            addCommodity() {
                this.myDialog = true;
                this.addProduct = true;
            },
            //该方法的主要作用是根据销售属性的saleList的赋值进行生成商品列表skuList来填写金额和数量，
            //比如saleList中有颜色属性，选择了红色等，然后该方法就会生成颜色-数量-价格的商品列表.
            //这里我的实现比较复杂，实现过程如下:
            getCommodityList() {
                this.commodityListShow = false;
                if (this.saleList.length > 0) {
                    //首先因为saleList的数据对象的value其实是内容所对应的vid，
                    //比如颜色属性，选了红色，实际saleList中对象的value不是红色，而是所对应的vid1004
                    //那么为了让用户看到红色而不是1004这种不知其意的数值，我先进行的是将saleList格式化，即将value变成vid所对应的name
                    //简单来说就是将[{value:[1004,...]},...]变成[{value:[{cid:1004,valueName:'红色'},...]},...]
                    for (var i = this.saleList.length - 1; i >= 0; i--) {
                        if (this.saleList[i].value instanceof Array) {
                            var value = [];
                            for (var j = 0; j < this.saleList[i].value.length; j++) {
                                for (var k = 0; k < this.saleList[i].values.length; k++) {
                                    //这一步判断的目的是以防saleList已经格式化后再做格式化,否则将会格式化value为[]而导致skulist为空,即商品列表为空.
                                    if (this.saleList[i].value[j].valueName != "" && this.saleList[i].value[j]
                                        .valueName != null) {
                                        value.push(this.saleList[i].value[j]);
                                        break;
                                    }
                                    if (this.saleList[i].value[j] == this.saleList[i].values[k].vid) {
                                        var valueItem = {
                                            cid: this.saleList[i].value[j],
                                            valueName: this.saleList[i].values[k].name
                                        };
                                        value.push(valueItem);
                                    }
                                }
                            }
                            this.saleList[i].value = value;
                        }
                    }
                    this.skuList = [];
                    var list = this.saleList;
                    //将销售属性转换为sku属性list，即商品列表，并将此渲染到页面上进行展示
                    if (list.length > 1) {
                        for (var i = 0; i < list[0].value.length; i++) {
                            var tempList = [];
                            var temp = {
                                pid: list[0].pid,
                                vid: list[0].value[i].cid,
                                isProp: true,
                                isMoney: false,
                                isCount: false,
                                adminProp: list[0].adminProp,
                                valueName: list[0].value[i].valueName
                            }
                            tempList.push(temp);
                            this.getSkuList(tempList, list.slice(1, list.length));
                        }
                    } else {
                        for (var i = 0; i < list[0].value.length; i++) {
                            var tempList = [];
                            var temp = {
                                pid: list[0].pid,
                                vid: list[0].value[i].cid,
                                isProp: true,
                                isMoney: false,
                                isCount: false,
                                adminProp: list[0].adminProp,
                                valueName: list[0].value[i].valueName
                            }
                            var saleMoney = {
                                money: '',
                                isProp: false,
                                isCount: false,
                                isMoney: true
                            }
                            var saleCount = {
                                count: '10000',
                                isProp: false,
                                isMoney: false,
                                isCount: true
                            }
                            tempList.push(temp);
                            tempList.push(saleMoney);
                            tempList.push(saleCount);
                            this.skuList.push(tempList);
                        }
                    }
                } else {
                    var tempList = [];
                    var temp = {
                        pid: '',
                        vid: '',
                        isProp: true,
                        isMoney: false,
                        isCount: false,
                        adminProp: false,
                        valueName: '默认'
                    }
                    var saleMoney = {
                        money: '',
                        isProp: false,
                        isCount: false,
                        isMoney: true
                    }
                    var saleCount = {
                        count: '10000',
                        isProp: false,
                        isMoney: false,
                        isCount: true
                    }
                    tempList.push(temp);
                    tempList.push(saleMoney);
                    tempList.push(saleCount);
                    this.skuList.push(tempList);
                }
                this.commodityListShow = true;
            },
            getSkuList(tempList, list) {
                if (list.length > 1) {
                    for (var i = 0; i < list[0].value.length; i++) {
                        var itemList = [];
                        for (var k = 0; k < tempList.length; k++) {
                            itemList.push(tempList[k]);
                        }
                        var temp = {
                            pid: list[0].pid,
                            vid: list[0].value[i].cid,
                            isProp: true,
                            isMoney: false,
                            isCount: false,
                            adminProp: list[0].adminProp,
                            valueName: list[0].value[i].valueName
                        }
                        itemList.push(temp);
                        this.getSkuList(itemList, list.slice(1, list.length));
                    }
                } else {
                    for (var i = 0; i < list[0].value.length; i++) {
                        var itemList = [];
                        for (var k = 0; k < tempList.length; k++) {
                            itemList.push(tempList[k]);
                        }
                        var temp = {
                            pid: list[0].pid,
                            vid: list[0].value[i].cid,
                            isProp: true,
                            isMoney: false,
                            isCount: false,
                            adminProp: list[0].adminProp,
                            valueName: list[0].value[i].valueName
                        }
                        var saleMoney = {
                            money: '',
                            isProp: false,
                            isCount: false,
                            isMoney: true
                        }
                        var saleCount = {
                            count: '10000',
                            isProp: false,
                            isMoney: false,
                            isCount: true
                        }
                        itemList.push(temp);
                        itemList.push(saleMoney);
                        itemList.push(saleCount);
                        this.skuList.push(itemList);
                    }
                }
            },
            handleClose() {
                var thiz = this;
                this.$confirm('关闭后数据将丢失，确认关闭？')
                    .then(_ => {
                        thiz.delAll();
                        done();
                    }).catch(_ => {});
            },
            //创建商品
            commodityMethod(method) {
                var list = [];
                if (method == "add" && this.selectList.length <= 0) {
                    this.$message.error("请将商品信息填写完整!");
                    return;
                }
                if (this.commodityName === "" || this.mainImage.length <= 0 || this.skuList.length <= 0) {
                    this.$message.error("请将商品信息填写完整!");
                    return;
                }
                for (var i = 0; i < this.skuList.length; i++) {
                    var skuCombination = "";
                    var skuCombinationClient = "";
                    var price = "";
                    var quantity = "";
                    var item = this.skuList[i];
                    for (var j = 0; j < item.length; j++) {
                        if (item[j].isProp) {
                            if (item[j].pid == '' && item[j].vid == '') {
                                continue;
                            }
                            if (item[j].pid !== '' && item[j].vid == '') {
                                this.$message.error("请将商品信息填写完整!");
                                return;
                            }
                            if (!item[j].adminProp) {
                                skuCombinationClient += item[j].pid + ":" + item[j].vid + ";";
                            }
                            skuCombination += item[j].pid + ":" + item[j].vid + ";";
                        } else if (item[j].isMoney) {
                            if (item[j].isMoney <= 0) {
                                this.$message.error("请将商品信息填写正确!");
                                return;
                            }
                            price = item[j].money;
                        } else if (item[j].isCount) {
                            if (item[j].count <= 0) {
                                this.$message.error("请将商品信息填写正确!");
                                return;
                            }
                            quantity = item[j].count;
                        }
                    }
                    var temp = {
                        skuCombination: skuCombination.substring(0, skuCombination.length - 1),
                        skuCombinationClient: skuCombinationClient.substring(0, skuCombinationClient.length - 1),
                        price: price,
                        quantity: quantity
                    }
                    list.push(temp);
                }
                this.customerProps = "";
                this.binds = "";
                //因为绑定属性和自定义属性与销售属性格式化是有所不同的，所以需要两个方法来分别为这几个属性进行格式
                //同时在格式化属性时，也判断是否填写为空来进行提示。
                if (!this.getStandardStr(this.keyList) || !this.getStandardStrForSale(this.saleList) || !this
                    .getStandardStr(this.otherList)) {
                    this.$message.error("请将商品信息填写完整!");
                    return;
                }
                this.customerProps = this.customerProps.substring(0, this.customerProps.length - 1);
                this.binds = this.binds.substring(0, this.binds.length - 1);
                var images = [];
                for (var i = 0; i < this.mainImage.length; i++) {
                    var s = this.mainImage[i].url.indexOf('_');
                    var e = this.mainImage[i].url.lastIndexOf('.');
                    images.push(this.mainImage[i].url.substring(0, s) + this.mainImage[i].url.substring(e));
                }
                if (method == "add") {
                    this.loadingForAdd = true
                    var thiz = this;
                    axios.post(this.$store.getters.getApiValue + '/product/add.do', {
                        cid: this.selectList[this.selectList.length - 1].value,
                        name: this.commodityName,
                        description: this.description,
                        mainImage: images,
                        customerProps: this.customerProps,
                        saleProps: this.saleStr,
                        binds: this.binds,
                        skuList: list
                    }).then(response => {
                        var data = response.data;
                        if (data.status == "200") {
                            if (data.data != "" && data.data != null) {
                                thiz.$message.success("创建成功");
                                thiz.delAll();
                                thiz.updateTable();
                            } else {
                                thiz.$message.error("创建失败");
                            }
                        } else {
                            thiz.$message.error(data.message);
                        }
                    }).catch(function(error) {
                        thiz.$message.error("系统异常,请与管理员联系!");
                    }).finally(() => {
                        this.loadingForAdd = false
                    })
                } else if (method == "update") {
                    this.loadingForUpdate = true
                    var thiz = this;
                    axios.post(this.$store.getters.getApiValue + '/product/update.do?productId=' + this.productId, {
                        cid: this.cid,
                        productId: this.productId,
                        name: this.commodityName,
                        description: this.description,
                        mainImage: images,
                        customerProps: this.customerProps,
                        saleProps: this.saleStr,
                        binds: this.binds,
                        skuList: list
                    }).then(response => {
                        var data = response.data;
                        if (data.status == "200") {
                            if (data.data != "" && data.data != null) {
                                thiz.$message.success("修改成功");
                                thiz.delAll();
                                thiz.updateTable();
                            } else {
                                thiz.$message.error("error")
                            }
                        } else {
                            thiz.$message.error(data.message);
                        }
                    }).catch(function(error) {
                        thiz.$message.error("系统异常,请与管理员联系!");
                    }).finally(() => {
                        this.loadingForUpdate = false
                    })
                }
            },
            getStandardStr(list) {
                var cusStr = '';
                var bindStr = '';
                for (var i = 0; i < list.length; i++) {
                    if (list[i].value.length <= 0) {
                        this.$message.error("请将商品信息填写完整!");
                        return false;
                    }
                    if (list[i].enumProp) {
                        if (list[i].value instanceof Array) {
                            var value = list[i].value;
                            for (var j = 0; j < value.length; j++) {
                                bindStr += list[i].pid + ":" + value[j] + ";";
                            }
                        } else {
                            bindStr += list[i].pid + ":" + list[i].value + ";";
                        }
                    } else {
                        cusStr += list[i].pid + ":" + list[i].value + ";";
                    }
                }
                this.customerProps += cusStr;
                this.binds += bindStr;
                return true;
            },
            getStandardStrForSale(list) {
                var propsStr = '';
                for (var i = 0; i < list.length; i++) {
                    if (list[i].value.length <= 0) {
                        this.$message.error("请将商品信息填写完整!");
                        return false;
                    }
                    if (list[i].value instanceof Array) {
                        var value = list[i].value;
                        for (var j = 0; j < value.length; j++) {
                            propsStr += list[i].pid + ":" + value[j].cid + ";";
                        }
                    } else {
                        propsStr += list[i].pid + ":" + list[i].value + ";";
                    }
                }
                this.saleStr = propsStr.substring(0, propsStr.length - 1);
                return true;
            },
            //获取商品信息
            updateCommodity(row) {
                var thiz = this;
                this.category = row.category;
                this.productId = row.productId;
                axios.get(this.$store.getters.getApiValue + '/product/get.do', {
                    params: {
                        productId: row.productId
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        console.log(data);
                        var initList = [];
                        for (var i = 0; i < data.data.othersPropsList.length; i++) {
                            initList.push(data.data.othersPropsList[i]);
                        }
                        for (var i = 0; i < data.data.salePropsList.length; i++) {
                            initList.push(data.data.salePropsList[i]);
                        }
                        thiz.cid = data.data.cid;
                        axios.get(thiz.$store.getters.getApiValue + '/category/listByCid.do', {
                            params: {
                                cid: data.data.cid
                            }
                        }).then(function(response) {
                            var data1 = response.data;
                            if (data1.status == "200") {
                                var list = data1.data;
                                thiz.keyProps = [];
                                thiz.saleProps = [];
                                thiz.otherProps = [];
                                thiz.commodityList = [];
                                for (var i = 0; i < list.length; i++) {
                                    for (var j = 0; j < initList.length; j++) {
                                        if (initList[j].pid == list[i].pid) {
                                            var commodityItem = {
                                                pid: list[i].pid,
                                                enumProp: list[i].enumProp,
                                                multi: list[i].multi,
                                                values: list[i].values,
                                                name: list[i].name,
                                                adminProp: list[i].adminProp,
                                                value: ""
                                            }
                                            if (list[i].enumProp) {
                                                if (list[i].multi) {
                                                    var value = [];
                                                    for (var k = 0; k < initList[j].vlist.length; k++) {
                                                        value.push(initList[j].vlist[k].vid);
                                                    }
                                                    commodityItem.value = value;
                                                } else {
                                                    commodityItem.value = initList[j].vlist[0].vid;
                                                }
                                            } else {
                                                commodityItem.value = initList[j].vlist[0].vname;
                                            }
                                            if (list[i].keyProp && !list[i].saleProp) {
                                                thiz.keyProps.push(commodityItem);
                                                thiz.keyList.push(commodityItem);
                                            } else if (!list[i].keyProp && list[i].saleProp) {
                                                thiz.saleProps.push(commodityItem);
                                                thiz.saleList.push(commodityItem);
                                            } else {
                                                thiz.otherProps.push(commodityItem);
                                                thiz.otherList.push(commodityItem);
                                            }
                                            break;
                                        }
                                    }
                                }
                                thiz.commodityName = data.data.name;
                                thiz.description = data.data.description;
                                thiz.mainImage = [];
                                for (var i = 0; i < data.data.mainImage.length; i++) {
                                    var image = thiz.$options.methods.smallImage(data.data.mainImage[
                                    i]);
                                    thiz.mainImage.push({
                                        name: "",
                                        url: image
                                    });
                                }
                                thiz.skuList = [];
                                for (var i = 0; i < data.data.skuProductList.length; i++) {
                                    var skuItem = [];
                                    for (var j = 0; j < data.data.skuProductList[i].propertiesList
                                        .length; j++) {
                                        var temp = {
                                            pid: data.data.skuProductList[i].propertiesList[j].pid,
                                            vid: data.data.skuProductList[i].propertiesList[j]
                                                .value,
                                            adminProp: data.data.skuProductList[i].propertiesList[j]
                                                .adminProp,
                                            isProp: true,
                                            isMoney: false,
                                            isCount: false,
                                            valueName: data.data.skuProductList[i].propertiesList[j]
                                                .valueName
                                        }
                                        skuItem.push(temp);
                                    }
                                    var saleMoney = {
                                        money: data.data.skuProductList[i].price,
                                        isProp: false,
                                        isCount: false,
                                        isMoney: true
                                    }
                                    var saleCount = {
                                        count: data.data.skuProductList[i].quantity,
                                        isProp: false,
                                        isMoney: false,
                                        isCount: true
                                    }
                                    skuItem.push(saleMoney);
                                    skuItem.push(saleCount);
                                    thiz.skuList.push(skuItem);
                                }
                                thiz.commodityListShow = true;
                                thiz.commodityShow = true;
                                thiz.myDialog = true;
                                thiz.updateProduct = true;
                            } else {
                                thiz.$message.error(data1.message);
                            }
                        }).catch(function(error) {
                            console.log(error);
                            thiz.$message.error("系统异常,请与管理员联系!");
                        });
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    console.log(error);
                    thiz.$message.error("系统异常,请与管理员联系!");
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.updateTable();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.updateTable();
            },
            updateTable() {
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/product/listByCid.do', {
                    params: {
                        cid: 0,
                        pageId: thiz.currentPage,
                        size: thiz.pageSize
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.total = data.totalCount;
                        thiz.commodityData = data.data;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    console.log(error);
                    thiz.$message.error("系统异常,请与管理员联系!");
                });
            },
            readyUpdateProfitSharing(row) {
                this.profitSharingDialog = true;
                this.sid = row.sid;
                this.updateSchemeProductId.productId = row.productId;
                console.log(row);
                this.getProfitSharingSchemes();
            },
            getProfitSharingSchemes() {
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/profitSharingScheme/all.do', {}).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.total = data.totalCount;
                        thiz.profitSharingSchemes = data.data;
                        thiz.profitSharingSchemes.unshift({sid:0,name:"无"});
                    }
                }).catch(function(error) {
                    console.log(error);
                });
            },
            updateProfitSharingScheme() {
                var params = {
                    productId: this.updateSchemeProductId.productId,
                    sid: this.sid,
                }
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/profitSharingScheme/setScheme.do', {
                        params: params
                    })
                    .then(function(response) {
                        var data = response.data
                        if (data.status == '200') {
                            if (data.data) {
                                thiz.$message.success('操作成功！')
                                thiz.profitSharingDialog = false;
                                thiz.updateTable()
                            } else {
                                thiz.$message.success('操作失败！')
                                thiz.profitSharingDialog = false;
                                thiz.updateTable()
                            }
                        } else {
                            thiz.$message.error(data.message)
                        }
                    })
                    .catch(function(error) {
                        thiz.$message.error('系统异常!请与管理员联系!')
                        thiz.profitSharingDialog = false;
                    })
            },
            delAll() {
                this.commodityShow = false;
                this.commodityListShow = false;
                this.selectList = [];
                this.saleList = [];
                this.skuList = [];
                this.keyList = [];
                this.otherList = [];
                this.commodityName = "";
                this.mainImage = [];
                this.description = "";
                this.myDialog = false;
                this.addProduct = false;
                this.updateProduct = false;
            },
            //headClass和rowClass用于设置table 表头和行样式.
            headClass({
                row,
                rowIndex
            }) {
                if (rowIndex == 0) {
                    return ''
                }
                return ''
            },
            rowClass({
                row,
                rowIndex
            }) {
                if (rowIndex % 2 == 0) {
                    return 'background:#F1F2F7;'
                } else {
                    return 'background:white;'
                }
                return ''
            },
            //删除商品
            deleteCommodity() {
                if (this.multipleSelection == null || this.multipleSelection.length == 0) {
                    this.$message.error("你还未选择商品!");
                    return;
                }
                var productId = "";
                var productName = "";
                for (var i = 0; i < this.multipleSelection.length; i++) {
                    productId = productId + this.multipleSelection[i].productId + ",";
                    productName = productName + this.multipleSelection[i].name + ",";
                }
                var thiz = this;
                this.$confirm("确认删除商品" + productName.substring(0, productName.length - 1) + '吗?')
                    .then(_ => {
                        axios.get(thiz.$store.getters.getApiValue + '/product/delete.do', {
                            params: {
                                productIds: productId.substring(0, productId.length - 1)
                            }
                        }).then(response => {
                            var data = response.data;
                            if (data.status == "200") {
                                if (data.data != "" && data.data != null) {
                                    thiz.$message.success("删除成功!");
                                    thiz.$refs.multipleTable.clearSelection();
                                    thiz.updateTable();
                                }
                            } else {
                                thiz.$message.error(data.message);
                            }
                        }).catch(function(error) {
                            thiz.$message.error("系统异常,请与管理员联系!");
                        })
                    }).catch(_ => {});
            },
            handleAvatarSuccess(res, file) {
                var image = this.$options.methods.smallImage(res.data);
                this.mainImage.push({
                    name: "",
                    url: image
                });
            },
            beforeAvatarUpload(file) {},
            handleRemove(file, fileList) {
                console.log(file)
                console.log(fileList)
                this.mainImage = [];
                for (var i = 0; i < fileList.length; i++) {
                    this.mainImage.push({
                        name: "",
                        url: fileList[i].url.substring(fileList[i].url.indexOf(":") + 1, fileList[i].url.length)
                    });
                }
                console.log(this.mainImage);
            },
            smallImage(url) {
                var f = url.substring(0, url.lastIndexOf("."));
                var s = url.substring(url.lastIndexOf("."));
                return f + "_160x160" + s;
            },
            //移除skuList的部分项目
            removeFromSkuList(item,index){
                this.skuList.splice(index,1);
                // console.log(JSON.stringify(this.skuList)),
                // console.log(JSON.stringify(item));
            }
        }
    }
</script>

<style scoped>
    .tdClass {
        width: 90px;
    }

    .tableClass {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0px 10px;
    }

    .el-dialog__body {
        min-height: 300px;
    }

    #addImg:hover {
        cursor: pointer;
    }

    .el-table {
        font-size: 12px;
        border-bottom: 1px solid #dcd8d8;
        color: black;
    }

    .el-table tr th {
        border-top: 0px;
        border-left: 0px;
        border-right: 0px;
    }

    .el-table tr td {
        border-bottom: 1px solid #dcd8d8;
    }

    .hrClass {
        width: 100%;
        margin: 0 auto;
        border: 0;
        height: 1px;
        background: #fff;
        background-image: linear-gradient(to right, #adabab, #adabab, #fff);
    }

    .avatarDiv .el-upload--picture-card {
        width: 50px;
        height: 50px;
        line-height: 55px;
    }

    .avatarDiv .el-upload-list--picture-card .el-upload-list__item {
        width: 50px;
        height: 50px;
    }
</style>